
import 'react-multi-carousel/lib/styles.css';

export const About = () => {


  return (
    <section className="about" id="about">
         <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2><b>About Me!</b></h2>
                        <p>Avid backpacker with a knack for programming, harboring a deep-seated passion for the vibrant energy of NYC. Driven by wanderlust and code, dreams of merging tech skills with the city's dynamic pulse.</p>

                    </div>
                </div>
            </div>
        </div>

    </section>
  )
}
